export { TextLeftLayout } from "./text-left-layout.component";
export type {
  TextLeftLayoutProps,
  TextLeftTab,
} from "./text-left-layout.types";
